export default [
  {
    path: "/admins",
    name: "Admin",
    component: () => import("@/views/admin/Admin.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/admin/add",
    name: "create-admin",
    component: () => import("@/views/admin/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/admin/edit/:id",
    name: "edit-admin",
    component: () => import("@/views/admin/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/da",
    name: "da",
    component: () => import("@/views/da/Da.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/da/add",
    name: "da-add",
    component: () => import("@/views/da/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/da/edit/:id",
    name: "edit-da",
    component: () => import("@/views/da/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/clinic",
    name: "clinic",
    component: () => import("@/views/clinic/Clinic.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/clinic/add",
    name: "clinic-add",
    component: () => import("@/views/clinic/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/clinic/edit/:id",
    name: "edit-clinic",
    component: () => import("@/views/clinic/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/member",
    name: "member",
    component: () => import("@/views/member/Member.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/member/add",
    name: "member-add",
    component: () => import("@/views/member/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/member/edit/:id",
    name: "edit-member",
    component: () => import("@/views/member/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/pa",
    name: "pa",
    component: () => import("@/views/pa/Pa.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/pa/add",
    name: "pa-add",
    component: () => import("@/views/pa/Create.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/pa/edit/:id",
    name: "edit-pa",
    component: () => import("@/views/pa/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
];
